import './styles.scss'
import React, { useState, useEffect } from 'react'
import { t } from 'i18next'
import { supabase } from 'Services/supabaseClient'
import { InputSwitch } from 'primereact/inputswitch'
import { DialogModal } from 'Components/UIComponents'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

const UserSetting = ({ allUserData }) => {
  const { is_internal_user: isInternalUser, can_act_as_bot: canActAsBot } = allUserData
  const history = useHistory()

  const [isInternalUserChecked, setIsInternalUserChecked] = useState(isInternalUser)
  const [isBotUserChecked, setIsBotUserChecked] = useState(canActAsBot)
  const [showDialog, setShowDialog] = useState({ showModal: false, modalCancel: false, modalType: '', message: '', onDismiss: () => {}, onRetry: () => {}, onHide: () => {}, onSuccess: () => {}, onConfirmation: () => {} })

  useEffect(() => {}, [allUserData?.userid])

  const handleDismiss = () => {
    setShowDialog((prev) => ({ ...prev, showModal: false }))
  }

  const updateUserField = async (key, active, setter, previousValue, fieldName) => {
    setter(active)

    try {
      const payload = { [key]: active }

      const { data, error } = await supabase.from('users').update(payload).eq('userid', allUserData?.userid).select().single()

      if (error || !data) {
        setter(previousValue)
        setShowDialog((prev) => ({
          ...prev,
          showModal: true,
          modalType: 'error',
          message: t('USER_SETTING_UPDATE_FAILED'),
          onDismiss: handleDismiss,
          onHide: handleDismiss
        }))

        return
      }

      setter(Boolean(data[key]))

      const params = new URLSearchParams(history.location.search)

      history.replace({
        pathname: history.location.pathname,
        search: params.toString(),
        state: [{ ...allUserData, ...data }]
      })

      const actionText = active ? 'Added As' : 'Removed From'

      setShowDialog((prev) => ({
        ...prev,
        showModal: true,
        modalType: 'success',
        message: `${allUserData?.first_name} Has Been ${actionText} ${fieldName}.`,
        onDismiss: handleDismiss,
        onHide: handleDismiss
      }))
    } catch (err) {
      setter(previousValue)
      setShowDialog((prev) => ({
        ...prev,
        showModal: true,
        modalType: 'error',
        message: t('USER_SETTING_UPDATE_FAILED'),
        onDismiss: handleDismiss,
        onHide: handleDismiss
      }))
    }
  }

  /* eslint-disable  */
  const handleUserToggle = (key, e, setter, previousValue, activeMsg, inactiveMsg, fieldName) => {
    const isChecked = e.value

    setShowDialog({
      ...showDialog,
      showModal: true,
      modalType: 'info',
      message: isChecked ? activeMsg : inactiveMsg,
      modalCancel: false,
      onDismiss: handleDismiss,
      onConfirmation: () => updateUserField(key, isChecked, setter, previousValue, fieldName)
    })
  }

  const handleIsInternalUser = (e) => handleUserToggle('is_internal_user', e, setIsInternalUserChecked, isInternalUserChecked, `Are You Sure, You Want To Make ${allUserData?.first_name} An Internal User?`, `Are You Sure, You Want To Remove ${allUserData?.first_name} As Internal User?`, 'Internal User')

  const handleIsBotUser = (e) => handleUserToggle('can_act_as_bot', e, setIsBotUserChecked, isBotUserChecked, `Are You Sure, You Want To Make ${allUserData?.first_name} as Bot User?`, `Are You Sure, You Want To Remove ${allUserData?.first_name} As Bot User?`, 'Bot User')

  return (
    <div className="user-settings-container">
      <div className="container">
        <div className="row">
          <div className="left">
            <p>Internal User</p>
            <p>Make user as Internal User</p>
          </div>
          <div className="right toggle-switch-menu">
            <InputSwitch checked={isInternalUserChecked} onChange={(e) => handleIsInternalUser(e)} />
          </div>
        </div>
        <div className="row">
          <div className="left">
            <p>Bot User</p>
            <p>Allow user to act as bot</p>
          </div>
          <div className="right toggle-switch-menu">
            <InputSwitch checked={isBotUserChecked} onChange={(e) => handleIsBotUser(e)} />
          </div>
        </div>
      </div>

      <DialogModal {...showDialog} onSuccess={handleDismiss} onHide={handleDismiss} />
    </div>
  )
}

export default UserSetting
